function helperCreateTreeFunc (handle) {
  return function (obj, iterate, options, context) {
    var opts = options || {}
    var optChildren = opts.children || 'children'
    return handle(null, obj, iterate, context, [], [], optChildren, opts)
  }
}

module.exports = helperCreateTreeFunc



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperCreateTreeFunc.js
// module id = B1TM
// module chunks = 141